<template>
  <div class>
    <div class="row">
      <div class="col-sm-6 text-left">
        <span style="font-weight:bold; font-size:1.1em;margin-left:5px;">CANASTAS</span>
      </div>
      <div class="col-sm-6 text-right">
        <router-link  class="btn main-bg" :to="`/companies/${company}/basket/0`">
          <i class="fa fa-plus"></i>
          Crear Canasta
        </router-link>
      </div>
    </div>

    <!-- Lista -->
    <div class="row">
      <div class="col-sm-12">
        <div v-for="basket in baskets" :key="basket.id" class="card basket-card">
          <div class="card-heading" :style="'background-image:url('+(basket.photo || '/logo_blue.png')+')'"></div>
          <div class="card-body">
            <div class="row">
              <div class="col-6 text-left">
                <b>{{ basket.name }}</b>
              </div>
              <div class="col-6 text-right">${{ basket.price }}</div>
            </div>
            <p>{{ basket.description }}</p>
          </div>
          <div class="card-footer" style="display:flex;justify-content:space-between;">
            <router-link  class="main-green" :to="`/companies/${company}/basket/${basket.id}`">
              Ver detalles
            </router-link>
            <span style="font-size:10px;">ID: {{ basket.id }}</span>
          </div>
        </div>

        <div v-if="loading" class="text-center">
          <Loader />
        </div>

        <div v-if="!loading && baskets.length === 0" class="text-center">
          <h3 class="mt-5">No hay canastas</h3>
        </div>


      </div>
    </div>


  </div>
</template>

<script>
import { CompanyService } from '../../services/CompanyService';
import Loader from '../components/Loader'
export default {
  name: "Basket",
  props: ["company"],
  components: {Loader},
  data: function () {
    return {
      loading: false,
      baskets: [],
      companyService: new CompanyService(),
    };
  },
  methods: {
    async getBaskets() {
      this.loading = true;
      this.baskets = [];
      const response = await this.companyService.getCompanyBaskets(this.company);
      if(response.ok){
        this.baskets = response.baskets;
      }else{
        this.$helpers.message('Oops', response.message, 'error');
      }
      this.loading = false;
    },
  },
  beforeMount: async function () {
    await this.getBaskets();
  },
  watch: {
    filter(val){
      if(!val){
        return;
      }
      this.filteredProducts = this.products.filter(x => x.name.toLowerCase().includes(String(val).toLowerCase()));
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.fs1 {
  font-size: small;
}
.btn1 {
  padding: 3px;
}
* {
  font-weight: 500;
}
#selectable .ui-selecting {
  background: #6bd090;
}
#selectable .ui-selected {
  background: #6bd098;
  color: white;
}
.bg-lg {
  background-color: lightgray;
}
.seleccionado {
  background-color: #cecece;
  font-weight: bold;
}
.btn-less-padding {
  padding: 2px 6px;
}
.basket-card {
  border-radius: 5px;
  width: 300px;
  height: 300px;
  float: left;
  margin-right: 10px;
  margin-bottom: 10px;
  .card-heading {
    height: 130px;
    width: auto;
    background-position: center;
    background-size: cover;
  }
}
#basket-photo-preview img{
  height: 110px;
  width: 100%;
  object-fit: cover;
}
@media screen and (max-width: 450px) {
  .basket-card {
    width: 100%;
  }
}
</style>
